import React, { useState, useEffect } from "react";
import landingHeroContent from "../../Data/landingHeroContent.json";

function useCountUp(end, duration = 2000) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const increment = end / (duration / 16); // Approx. 60fps
        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(timer);
                setCount(end);
            } else {
                setCount(Math.ceil(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [end, duration]);

    return count;
}

const HeroSection = () => {
    const cities = useCountUp(landingHeroContent.stats[0].count, landingHeroContent.stats[0].duration);
    const clients = useCountUp(landingHeroContent.stats[1].count, landingHeroContent.stats[1].duration);
    const deliveries = useCountUp(landingHeroContent.stats[2].count, landingHeroContent.stats[2].duration);
    const drivers = useCountUp(landingHeroContent.stats[3].count, landingHeroContent.stats[3].duration);
    const owners = useCountUp(landingHeroContent.stats[4].count, landingHeroContent.stats[4].duration);
    const dhabas = useCountUp(landingHeroContent.stats[5].count, landingHeroContent.stats[5].duration);

    return (
        <div className="relative flex flex-col items-start justify-center h-screen text-left px-5 md:px-20 w-full bg-home-image bg-cover bg-center bg-no-repeat">
            <div className="absolute inset-0 bg-black/25"></div> {/* Dark overlay */}

            <div className="relative z-10">
                <h1 className="text-3xl md:text-5xl font-bold text-white">
                    {landingHeroContent.title} <span className="text-yellow-400">{landingHeroContent.name}</span>
                </h1>
                <h1 className="text-3xl md:text-5xl font-bold text-white">{landingHeroContent.subtitle}</h1>
                <p className="mt-4 max-w-lg md:max-w-2xl text-sm md:text-base text-white mb-2">{landingHeroContent.description}</p>
                {landingHeroContent.buttons.map((button, index) => (
                    <a key={index} href={button.link} className={button.class}>
                        {button.text}
                    </a>
                ))}
            </div>

            {/* Stats Section */}
            <div
                className="absolute bottom-[-0px] max-w-[100vw] left-[0px] flex flex-nowrap 
                justify-even items-start text-left bg-black bg-opacity-40 p-2 md:p-3 rounded-tr-full shadow-lg z-20 space-x-2 md:space-x-4
                md:space-x-10 text-white pr-4 overflow-hidden"
            >
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{cities.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center">{landingHeroContent.stats[0].label}</p>
                </div>
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{clients.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center">{landingHeroContent.stats[1].label}</p>
                </div>
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{deliveries.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center">{landingHeroContent.stats[2].label}</p>
                </div>
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{drivers.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center">{landingHeroContent.stats[3].label}</p>
                </div>
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{owners.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center">{landingHeroContent.stats[4].label}</p>
                </div>
                <div className="flex-shrink-0 min-w-0">
                    <p className="text-md md:text-4xl font-bold truncate">{dhabas.toLocaleString()}</p>
                    <p className="text-xs md:text-sm truncate text-center mr-2 md:mr-10">{landingHeroContent.stats[5].label}</p>
                </div>
            </div>

        </div>
    );
};

export default HeroSection;
